function TechImages({ styles, url }) {
  return <img className={styles} src={url} alt="js-image" />;
}

export default TechImages;
